import { createFileRoute, Link } from "@tanstack/react-router";
import { Button, COPY, PageHeader } from "@magarac/ui";
import { authClient } from "../../lib/auth-client";
import { useHasModule } from "../../lib/entitlements";
import { useIsOffice } from "../../lib/tenant";

export const Route = createFileRoute("/_app/more")({
  component: MorePage,
});

/** The rest of the menu on phones, where the bottom bar has room for six items. */
function MorePage() {
  const office = useIsOffice();
  const invoicing = useHasModule("invoicing");
  const links = office
    ? [
        ...(invoicing
          ? [
              { to: "/quotes", label: "Quotes" },
              { to: "/invoices", label: "Invoices" },
            ]
          : []),
        { to: "/import", label: "Import customers" },
        { to: "/services", label: "Services" },
        { to: "/schedule", label: "Who is on the schedule" },
        { to: "/team", label: `${COPY.team} and logins` },
        { to: "/settings", label: "Settings" },
      ]
    : [];
  return (
    <div className="mx-auto max-w-md">
      <PageHeader title="More" />
      <ul className="divide-y divide-line rounded-card border border-line bg-surface">
        {links.map((l) => (
          <li key={l.to}>
            <Link to={l.to} className="block p-4 text-base hover:bg-brand-50">
              {l.label}
            </Link>
          </li>
        ))}
        <li>
          <Link to="/account" className="block p-4 text-base hover:bg-brand-50">
            Your sign-in
          </Link>
        </li>
        <li>
          <Link to="/help" className="block p-4 text-base hover:bg-brand-50">
            Help
          </Link>
        </li>
      </ul>
      <Button
        variant="secondary"
        className="mt-6 w-full"
        onClick={async () => {
          await authClient.signOut();
          // Full reload: the next person on this phone sees none of the previous person's data.
          window.location.assign("/login");
        }}
      >
        Sign out
      </Button>
    </div>
  );
}
